import { oauthProviderClient } from '@better-auth/oauth-provider/client'
import {
  inferAdditionalFields,
  oneTimeTokenClient,
} from 'better-auth/client/plugins'
import { createAuthClient } from 'better-auth/react'
// Type-only: erased at build, so no server code is bundled into the client.
// Single-sources the session's extra fields (role, analyticsExcluded) from the
// server `additionalFields` config instead of re-declaring them here.
import type { Auth } from './index'

export const authClient = createAuthClient({
  baseURL:
    typeof window !== 'undefined'
      ? window.location.origin
      : (process.env.BETTER_AUTH_URL ?? 'http://localhost:3101'),
  plugins: [
    inferAdditionalFields<Auth>(),
    oauthProviderClient(),
    oneTimeTokenClient(),
  ],
})

export const { signIn, signUp, signOut, requestPasswordReset, resetPassword } =
  authClient
